var _ChatNetworkServiceInit_instances, _ChatNetworkServiceInit_socket, _ChatNetworkServiceInit_chatAdapter, _ChatNetworkServiceInit_isConnected, _ChatNetworkServiceInit_applyMyStatusEvent, _ChatNetworkServiceInit_applyUsersEvent, _ChatNetworkServiceInit_applyBotEvent, _ChatNetworkServiceInit_createWebSocketModel;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import { writable } from 'svelte/store';
import { ChatAdapter } from '../model/network/chat/ChatAdapter';
import { SocketChatCommand } from '../model/socket/command/SocketChatCommand';
import { SocketLoginCommand } from '../model/socket/command/SocketLoginCommand';
import { ModifyProfileCommand } from '../model/socket/command/SocketModifyProfileCommand';
import { NotifyUserCommand } from '../model/socket/command/SocketNotifyUserCommand';
import { SocketReactionCommand } from '../model/socket/command/SocketReactionCommand';
import { WebSocketModel } from '../model/socket/websocket/WebSocketModel';
import { HashGenerator } from '../util/hash/HashGenerator';
import { PushListService } from '../view/main/push/PushListService';
import { GroupedChatService } from './chat/GroupedChatService';
import { ChatService } from './ChatService';
import { SocketService } from './SocketService';
import { SoundService } from './SoundService';
import { ChatClipService } from './ChatClipService';
class ChatNetworkServiceInit {
    constructor() {
        _ChatNetworkServiceInit_instances.add(this);
        _ChatNetworkServiceInit_socket.set(this, null);
        _ChatNetworkServiceInit_chatAdapter.set(this, new ChatAdapter());
        _ChatNetworkServiceInit_isConnected.set(this, writable(false));
        _ChatNetworkServiceInit_applyMyStatusEvent.set(this, writable());
        _ChatNetworkServiceInit_applyUsersEvent.set(this, writable([]));
        _ChatNetworkServiceInit_applyBotEvent.set(this, writable([]));
    }
    get isConnected() {
        return __classPrivateFieldGet(this, _ChatNetworkServiceInit_isConnected, "f");
    }
    get applyMyStatusEvent() {
        return __classPrivateFieldGet(this, _ChatNetworkServiceInit_applyMyStatusEvent, "f");
    }
    get applyUsersEvent() {
        return __classPrivateFieldGet(this, _ChatNetworkServiceInit_applyUsersEvent, "f");
    }
    get applyBotsEvent() {
        return __classPrivateFieldGet(this, _ChatNetworkServiceInit_applyBotEvent, "f");
    }
    init(privateKey) {
        if (__classPrivateFieldGet(this, _ChatNetworkServiceInit_socket, "f")) {
            __classPrivateFieldGet(this, _ChatNetworkServiceInit_socket, "f").disconnect();
        }
        __classPrivateFieldSet(this, _ChatNetworkServiceInit_socket, __classPrivateFieldGet(this, _ChatNetworkServiceInit_instances, "m", _ChatNetworkServiceInit_createWebSocketModel).call(this, privateKey), "f");
        SocketService.chat = new SocketChatCommand(__classPrivateFieldGet(this, _ChatNetworkServiceInit_socket, "f"));
        SocketService.login = new SocketLoginCommand(__classPrivateFieldGet(this, _ChatNetworkServiceInit_socket, "f"));
        SocketService.modifyProfile = new ModifyProfileCommand(__classPrivateFieldGet(this, _ChatNetworkServiceInit_socket, "f"));
        SocketService.notifyUser = new NotifyUserCommand(__classPrivateFieldGet(this, _ChatNetworkServiceInit_socket, "f"));
        SocketService.reaction = new SocketReactionCommand(__classPrivateFieldGet(this, _ChatNetworkServiceInit_socket, "f"));
        __classPrivateFieldGet(this, _ChatNetworkServiceInit_socket, "f").onReceived((command) => {
            switch (command.commandType) {
                case 'applyMyStatus':
                    __classPrivateFieldGet(this, _ChatNetworkServiceInit_applyMyStatusEvent, "f").set(command.response);
                    break;
                case 'applyCurrentUserList':
                    __classPrivateFieldGet(this, _ChatNetworkServiceInit_applyUsersEvent, "f").set(command.response);
                    break;
                case 'applyCurrentBotList':
                    __classPrivateFieldGet(this, _ChatNetworkServiceInit_applyBotEvent, "f").set(command.response);
                    break;
                case 'applyCurrentChatList':
                    GroupedChatService.updateChats(__classPrivateFieldGet(this, _ChatNetworkServiceInit_chatAdapter, "f").toChats(command.response));
                    ChatService.requestScrollDown(true);
                    break;
                case 'drawer-update':
                    ChatClipService.updateClips(command.response);
                    break;
                case 'applyNotifyTo':
                    break;
                case 'reaction':
                    GroupedChatService.updateReactions(command.response.chatHash, command.response.reactions);
                    break;
                case 'applyNotifyFrom':
                    PushListService.push({
                        hash: new HashGenerator().generate('applyNotifyFrom'),
                        channel: 'alarm',
                        mute: false,
                        read: false,
                        timestamp: Number.parseInt(command.response.timestamp),
                        icon: command.response.from.icon,
                        title: command.response.from.nickname,
                        body: `"${command.response.from.nickname}"로 부터 알림이 왔어요.`,
                    });
                    SoundService.playNotificationSound();
                    break;
                case 'chat':
                    GroupedChatService.addChat(__classPrivateFieldGet(this, _ChatNetworkServiceInit_chatAdapter, "f").toChat(command.response));
                    ChatService.requestScrollDown();
                    break;
                case 'link-update':
                    GroupedChatService.updateLink(command.response.chatHash, command.response.title, command.response.thumbnail);
                    ChatService.requestScrollDown();
                    break;
            }
        });
        __classPrivateFieldGet(this, _ChatNetworkServiceInit_socket, "f").connect();
    }
}
_ChatNetworkServiceInit_socket = new WeakMap(), _ChatNetworkServiceInit_chatAdapter = new WeakMap(), _ChatNetworkServiceInit_isConnected = new WeakMap(), _ChatNetworkServiceInit_applyMyStatusEvent = new WeakMap(), _ChatNetworkServiceInit_applyUsersEvent = new WeakMap(), _ChatNetworkServiceInit_applyBotEvent = new WeakMap(), _ChatNetworkServiceInit_instances = new WeakSet(), _ChatNetworkServiceInit_createWebSocketModel = function _ChatNetworkServiceInit_createWebSocketModel(privateKey) {
    const socket = new WebSocketModel();
    socket.setOnOpen(() => {
        var _a;
        __classPrivateFieldGet(this, _ChatNetworkServiceInit_isConnected, "f").set(true);
        (_a = SocketService.login) === null || _a === void 0 ? void 0 : _a.execute(privateKey);
    });
    socket.setOnClose(() => {
        __classPrivateFieldGet(this, _ChatNetworkServiceInit_isConnected, "f").set(false);
        GroupedChatService.updateChats([]);
    });
    return socket;
};
export const ChatNetworkService = new ChatNetworkServiceInit();
